import React, { Component } from 'react'
import { injectIntl } from 'react-intl'

import { Layout, Content, Container, PageTitle } from 'src/components/Layout'
import List from 'src/components/List'
import intlMessages from './translations'

class WhatHappened extends Component {
  getListItems = () => {
    const { intl } = this.props

    return [
      {
        leftIcon: ['far', 'car-burst'],
        name: intl.formatMessage(intlMessages.whatHappendVehicleCollision),
        url: '/claims/what-happened/vehicle-collision',
        rightIcon: 'right',
        hideArrow: true,
      },
      {
        leftIcon: ['far', 'claw-marks'],
        name: intl.formatMessage(intlMessages.whatHappendWindshieldDamage),
        url: '/claims/what-happened/windshield-damage',
        rightIcon: 'right',
        hideArrow: true,
      },
      {
        leftIcon: ['far', 'car-rear'],
        name: intl.formatMessage(intlMessages.whatHappendHitAndRun),
        url: '/claims/what-happened/hit-and-run',
        rightIcon: 'right',
        hideArrow: true,
      },
      {
        leftIcon: ['far', 'tornado'],
        name: intl.formatMessage(intlMessages.whatHappendNaturalDisaster),
        url: '/claims/what-happened/natural-disaster',
        rightIcon: 'right',
        hideArrow: true,
      },
    ]
  }
  render() {
    const { intl } = this.props

    return (
      <Layout className='m-claims-what-happened claims-list'>
        <Content>
          <PageTitle
            title={intl.formatMessage(intlMessages.whatHappendHeadline)}
            subtitle={intl.formatMessage(intlMessages.claimsFillOutTheForm)}
          />
          <Container>
            <List items={this.getListItems()} isColumn={true} noMargin={true} />
          </Container>
        </Content>
      </Layout>
    )
  }
}

export default injectIntl(WhatHappened)
